export const ETHNICITY = [
    {
        value: '21',
        label: 'American Indian or Alaska Native'
    },
    {
        value: '22',
        label: 'Asian'
    },
    {
        value: '23',
        label: 'Black or African American'
    },
    {
        value: '24',
        label: 'Native Hawaiian or Other Pacific Islander'
    },
    {
        value: '25',
        label: 'White'
    },
    {
        value: '26',
        label: 'Mixed-Race'
    },
    {
        value: '27',
        label: 'Hispanic or Latino'
    },
    {
        value: '27',
        label: 'Other'
    }
];
